import { chatHtmlToPlainText } from '../utils';
import { formatSearchTimestamp, highlightSegments } from './message-search-utils';

interface MessageSearchResultRowProps {
  senderName: string;
  /** Stored chat HTML; rendered as plain text, never as markup. */
  content: string;
  createdAt: string;
  /** Terms to mark in the snippet. */
  terms: string[];
  /** Optional second line under the sender, e.g. the conversation a hit came from. */
  subtitle?: string;
}

/** Body of one search result: sender, timestamp, optional subtitle, highlighted snippet. */
export function MessageSearchResultRow({
  senderName,
  content,
  createdAt,
  terms,
  subtitle,
}: MessageSearchResultRowProps) {
  const plain = chatHtmlToPlainText(content);
  return (
    <>
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium truncate">{senderName}</span>
        <span className="text-[11px] text-muted-foreground flex-shrink-0 tabular-nums">
          {formatSearchTimestamp(createdAt)}
        </span>
      </div>
      {subtitle && <p className="text-[11px] text-muted-foreground truncate">{subtitle}</p>}
      <p className="text-[13px] text-foreground/80 line-clamp-2 mt-0.5">
        {highlightSegments(plain, terms).map((seg, i) =>
          seg.hit ? (
            <mark key={i} className="bg-primary/25 text-foreground rounded-sm px-0.5">
              {seg.text}
            </mark>
          ) : (
            <span key={i}>{seg.text}</span>
          ),
        )}
      </p>
    </>
  );
}
